import { get, pick, capitalize } from 'lodash';

import Api from '../../services/Api';

const createSchema = {
  title: 'createApiKey',
  type: 'object',
  additionalProperties: false,
  required: ['name', 'scopes'],
  properties: {
    name: {
      type: 'string',
      minLength: 5,
      maxLength: 50,
      errorMessage: {
        minLength: 'Name should have atleast 5 characters',
        maxLength: 'Name should have more than 50 characters',
      },
    },
    scopes: {
      type: 'object',
      selectAtleastOneScope: true,
      properties: {
        'user.read': {
          type: 'boolean',
        },
        'user.delete': {
          type: 'boolean',
        },
        'user.link': {
          type: 'boolean',
        },
      },
    },
  },
};

function resetFormErrors() {
  return {
    name: null,
    scopes: null,
  };
}

function resetForm() {
  return {
    name: '',
    scopes: {
      'user.read': false,
      'user.link': false,
      'user.delete': false,
    },
  };
}

function resetCreateKey() {
  return {
    data: null,
    isKeyCopied: false,
    isDownloaded: false,
  };
}

function resetValidations() {
  return {
    name: false,
    scopes: false,
  };
}

function reset() {
  return {
    keys: {
      active: [],
      expired: [],
      revoked: [],
    },
    currentAccountId: null,
    currentAppId: null,
    validations: resetValidations(),
    errors: [],
    formValidator: createSchema,
    createForm: resetForm(),
    formErrors: resetFormErrors(),
    createdKey: resetCreateKey(),
    keyToRevoke: null,
  };
}

const state = reset();

const actions = {
  async getKeysForCurrentAppId({ commit }, { filter }) {
    const accountId = state.currentAccountId;
    const appId = state.currentAppId;
    const response = await Api.get(
      `accounts/${accountId}/apps/${appId}/api_keys`,
      {
        contentType: 'json',
        params: {
          filter,
        },
      }
    );

    commit(`set${capitalize(filter)}Keys`, response.body);
  },

  async createKeyForCurrentAppId({}, data) {
    const accountId = state.currentAccountId;
    const appId = state.currentAppId;
    const response = await Api.post(
      `accounts/${accountId}/apps/${appId}/api_keys`,
      data
    );

    return response;
  },

  async revokeKey({}, keyId) {
    const accountId = state.currentAccountId;
    const appId = state.currentAppId;
    const response = await Api.put(
      `accounts/${accountId}/apps/${appId}/api_keys/${keyId}/revoke`
    );

    return response;
  },
};

const mutations = {
  setErrors(state, data) {
    state.errors = data;
  },

  setActiveKeys(state, data) {
    state.keys.active = data;
  },

  setExpiredKeys(state, data) {
    state.keys.expired = data;
  },

  setRevokedKeys(state, data) {
    state.keys.revoked = data;
  },

  resetFormErrors(state) {
    state.formErrors = resetFormErrors();
  },

  setCurrentAppId(state, id) {
    state.currentAppId = id;
  },

  setCurrentAccountId(state, id) {
    state.currentAccountId = id;
  },

  setKeyToRevoke(state, data) {
    state.keyToRevoke = data;
  },

  resetState(state) {
    Object.assign(state, reset());
  },

  resetForm(state) {
    state.createForm = resetForm();
  },

  resetValidations(state) {
    state.validations = resetValidations();
  },

  setCreatedKey(state, payload) {
    state.createdKey = { ...state.createdKey, ...payload };
  },

  resetCreateKey(state) {
    state.createdKey = resetCreateKey();
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
